// Screen `library` (plan §3.1, §9.8) — owner: library. Pages, presentations, document templates and
// dashboards in one place: spaces, the page tree, search, templates and trash.
import { createFileRoute } from '@tanstack/react-router';
import { LibrarySearch } from '../../../features/library/search-params';
import { LibraryPage } from '../../../features/library/LibraryPage';

export const Route = createFileRoute('/_app/library/')({
  validateSearch: LibrarySearch,
  component: LibraryRoute,
});

function LibraryRoute() {
  return <LibraryPage search={Route.useSearch()} />;
}
